import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
  color: PropTypes.string,
  size: PropTypes.number,
};

const FacebookCircleIcon = ({ color = '#B5BCBD', size = '40', ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 30 30"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g transform="translate(1 1)" fillRule="nonzero" fill={color}>
      <circle stroke={color} fillOpacity=".2" cx="14" cy="14" r="14" />
      <path d="M12.466 15.36v6.784h2.742V15.36h2.277l.352-2.644h-2.63v-1.7c0-.416.097-.737.274-.96.177-.21.514-.322 1.026-.322H17.9V7.377c-.48-.08-1.153-.112-2.034-.112-1.027 0-1.86.304-2.47.914-.625.608-.93 1.474-.93 2.58v1.956H10.19v2.645h2.276" />
    </g>
  </svg>
);

FacebookCircleIcon.propTypes = propTypes;

export default FacebookCircleIcon;
